import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "d3de9584-43e8-4edb-9890-0b31cc08c1ea",
  publicId: "3",
  name: "Bark Bands (Critical Bands)",
  difficulty: 1,
  contentTypes: { audio: true, interactive: false, video: false },
  body: [principle01, task01],
};

export default lesson;
